/**
 * @fileoverview POST handler for the
 * "/companies/:company_id/custom_domains/:domain_type/:domain_id/migration" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postCompaniesCompanyIdCustomDomainsDomainTypeDomainIdMigrationCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdCustomDomainsDomainTypeDomainIdMigrationProps,
  PostCompaniesCompanyIdCustomDomainsDomainTypeDomainIdMigrationResult,
  PostCompaniesCompanyIdCustomDomainsDomainTypeDomainIdMigrationResultErrors,
} from "./types";

/**
 * POST handler for the
 * "/companies/:company_id/custom_domains/:domain_type/:domain_id/migration" endpoint
 */
export const postCompaniesCompanyIdCustomDomainsDomainTypeDomainIdMigration = reactQueryMutationAdapter(
  postCompaniesCompanyIdCustomDomainsDomainTypeDomainIdMigrationCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostCompaniesCompanyIdCustomDomainsDomainTypeDomainIdMigrationResultErrors>()(
    ({
      companyId,
      domainType,
      domainId,
      action,
      migrationType,
    }: PostCompaniesCompanyIdCustomDomainsDomainTypeDomainIdMigrationProps): Promise<PostCompaniesCompanyIdCustomDomainsDomainTypeDomainIdMigrationResult> => {
      return fetch(
        `/companies/${companyId}/custom_domains/${domainType}/${domainId}/migration`,
        "POST",
        {
          action,
          migration_type: migrationType,
        },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
